const fromdata = [
  {
    inputdata: "",
    title: "原经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    btx: "true"
  },
  {
    inputdata: "",
    title: "经销商编号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
  },
  {
    inputdata: "",
    title: "经销商类型 ",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
  },
  {
    inputdata: "",
    title: "调出仓库",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    btx: "true"
  },
];
export default fromdata;
